// SCRIPTURIA · Konto-Zugangslogik (Schritt 2/4).
// Entscheidet anhand des Nutzerprofils, wohin nach dem Login navigiert wird.
//
// Felder im Nutzerdokument:
//   study_unlocked  : bool  → Zugang zum Bibelstudium / SCRIPTURIA
//   study_source    : str   → 'bibelstudium' (reine Studiums-Anmeldung) | 'dashboard' | 'admin'
//   roles           : []    → Holyfire-interne Rollen (Admins etc.)
//   holyfire_access : bool  → optional: später zusätzlich bei Holyfire registriert

const HOLYFIRE_ROLES = ['MainAdmin', 'ExtAdmin', 'CEO'];

export function accountAccess(user) {
  if (!user) return { hasStudy: false, hasHolyfire: false };
  // SCRIPTURIA ist für jedes angemeldete Holyfire-Konto offen (kein Freischalt-Gate mehr).
  const hasStudy = true;
  const roles = Array.isArray(user.roles) ? user.roles : [];
  const isAdmin = roles.some((r) => HOLYFIRE_ROLES.includes(r));
  // Reine Bibelstudium-Anmeldung ⇒ kein Holyfire-Dashboard, außer der Nutzer
  // hat sich später zusätzlich bei Holyfire registriert (holyfire_access) oder ist Admin.
  const hasHolyfire = !!user.holyfire_access || isAdmin || user.study_source !== 'bibelstudium';
  return { hasStudy, hasHolyfire };
}

// SCRIPTURIA · Admin-Zugangslogik.
// Eigene, separat vergebbare Berechtigung (Rolle 'ScripturiaAdmin'), unabhängig
// von den Holyfire-Admin-Rollen. Superadmins (MainAdmin/CEO) sehen beides.
export const SCRIPTURIA_ADMIN_ROLE = 'ScripturiaAdmin';

export function adminAccess(user) {
  const roles = Array.isArray(user?.roles) ? user.roles : [];
  const isSuper = roles.includes('MainAdmin') || roles.includes('CEO');
  const hasHolyfire = isSuper || roles.includes('ExtAdmin');
  const hasScripturia = isSuper || roles.includes(SCRIPTURIA_ADMIN_ROLE);
  return { hasHolyfire, hasScripturia, isSuper, isAnyAdmin: hasHolyfire || hasScripturia };
}

// Wohin führt der „Admin"-Einstieg je nach Rechten?
//  - beide Admin-Bereiche → Auswahlseite (/admin-auswahl)
//  - nur Scripturia        → /scripturia/admin
//  - nur Holyfire          → /admin
export function adminTarget(user) {
  const { hasHolyfire, hasScripturia } = adminAccess(user);
  if (hasHolyfire && hasScripturia) return '/admin-auswahl';
  if (hasScripturia) return '/scripturia/admin';
  if (hasHolyfire) return '/admin';
  return '/';
}

// Zielroute nach dem Login:
//  - beide Zugänge       → Auswahlseite (/willkommen)
//  - nur Studium         → SCRIPTURIA (/scripturia)
//  - nur Holyfire / Rest → Dashboard (/dashboard)
export function decideLanding(user) {
  const { hasStudy, hasHolyfire } = accountAccess(user);
  if (hasStudy && hasHolyfire) return '/willkommen';
  if (hasStudy && !hasHolyfire) return '/scripturia/workspace';
  return '/dashboard';
}
